// const url_header = process.env.API_ROOT; //获取当前环境下的域名
// const url_header = 'https://api-dev.xiaochengdaren.com/';//测试
const url_header = 'https://xiaochengdaren.com/';//正式
export const userLogin = url_header + 'mini/mini-master-user/login'; //登录
export const getCode = url_header + 'web/login/login'; //登录二维码
export const imgUpload = url_header + 'mini/mini-task/task-img-upload'; //图片上传
export const sentSms = url_header + 'mini/mini-master-user/sent-sms'; //短信验证码
export const getConfig = url_header + 'admin/conf-info/get-config'; //获取会员价格 获取题目 获取培训教程 达人最低提现金额
export const orderList = url_header + 'mini/mini-task/task-order-list'; //企业/达人订单列表
export const userAuth = url_header + 'mini/mini-master-user/auth'; //认证
export const homeBanner = url_header + 'web/home/home'; //轮播图web_banner
export const newsData = url_header + 'web/home/news-data'; //消息中心
export const newsInfo = url_header + 'web/home/news-info'; //消息中心
export const addBusiness = url_header + 'web/home/add-business'; //招商加盟
export const taskList = url_header + 'mini/mini-task/home'; //任务大厅列表
export const taskDetail = url_header + 'mini/mini-task/task-detailed'; //任务详情
export const rushOrder = url_header + 'mini/mini-task/rush-order'; //达人接单
export const homeData = url_header + 'web/home/home-data'; //平台数据统计
export const getIndenty = url_header + 'mini/mini-master-user/identy'; //获取企业行业
export const rechargePrice = url_header + 'mini/mini-master-user/recharge-price'; //获取充值套餐
export const epInfo = url_header + 'web/ep-web/ep-info'; //企业信息
export const epOrderDetail = url_header + 'web/ep-web/task-order-detail'; //企业订单详情
export const epBalance = url_header + 'mini/mini-master-user/enterprise-balance'; //企业余额明细
export const taskType = url_header + 'mini/mini-master-user/task-type'; //任务类型
export const epTaskAdd = url_header + 'mini/mini-task/task-add'; //企业发布推广
export const priceType = url_header + 'mini/mini-master-user/price-type'; //获取任务价格套餐
export const epRecharge = url_header + 'mini/mini-master-user/ep-recharge'; //企业充值余额
export const upgradeMember = url_header + 'mini/mini-master-user/upgrade-member'; //企业开通会员
export const taskEdit = url_header + 'mini/mini-task/task-save'; //任务重新编辑
export const taskCancel = url_header + 'mini/mini-task/task-cancel'; //任务取消
export const accountList = url_header + 'index.php/mini/mini-master-user/ep-operater'; //运营者列表
export const addAccount = url_header + 'index.php/mini/mini-master-user/add-operater'; //添加运营者
export const delAccount = url_header + 'index.php/mini/mini-master-user/del-operater'; //删除运营者
export const loginAccount = url_header + 'index.php/mini/mini-master-user/operater-login'; //登录运营者
export const payBalance = url_header + 'mini/mini-task/pay-notify-balance'; //余额支付订单
export const payWeChat = url_header + 'mini/mini-task/pay-task'; //余额支付订单
export const payResult = url_header + 'web/home/pay-result'; //支付结果查询
export const occupation = url_header + 'mini/mini-master-user/occupation'; //获取达人职业
export const trainList = url_header + 'mini/mini-master-user/train-list'; //获取培训时间
export const myDarenInfo = url_header + 'web/pc-web/pc-info'; //达人信息
export const darenTaskOrderDetail = url_header + 'web/pc-web/task-order-detail'; //达人订单详情
export const personalBalance = url_header + 'mini/mini-master-user/personal-balance'; //达人余额明细
export const withdrawal = url_header + 'mini/mini-master-user/withdrawal'; //达人提现验证
export const addWithdrawal = url_header + 'mini/mini-master-user/add-withdrawal-info'; //达人立即提现
export const getArea = url_header + 'admin/conf-info/get-area'; //获取区域列表
export const savePcInfo = url_header + 'admin/pc-user/save-pc-info'; //线上培训信息填写
export const checkAddress = url_header + 'web/pc-web/check-address'; //获取当前定位
export const newbieTask = url_header + 'mini/mini-master-user/newbie-task'; //新手任务进度
export const newbieTaskUrl = url_header + 'mini/mini-master-user/newbie-forward'; //新手任务url

export const gethomepc =url_header+'admin/conf-info/get-config';//设置内容

export const getAgentEp = url_header + 'web/pc-web/get-agent-ep'; //获取站长关联的企业
export const agentTaskAdd = url_header + 'mini/mini-task/task-add'; //站长代客下单
export const agentTaskList = url_header + 'web/pc-web/agent-task-list'; //站长代客下单列表
export const agentTaskDetail = url_header + 'web/ep-web/task-order-detail'; //站长代客下单订单详情
export const UpdateTask = url_header + 'web/ep-web/update-task'; //企业更新站长下单订单内容

export const couponList = url_header + 'mini/coupon/list'; //优惠券列表
export const couponInfo = url_header + 'mini/coupon/info'; //优惠券详情
export const couponAdd = url_header + 'mini/coupon/add'; //新增优惠券
export const couponDelete = url_header + 'mini/coupon/delete'; //删除优惠券
export const couponUpdate = url_header + 'mini/coupon/update'; //编辑优惠券

export const experienceCardList = url_header + 'mini/experience-card/list'; //体验卡列表
export const experienceCardInfo = url_header + 'mini/experience-card/info'; //体验卡详情
export const experienceCardAdd = url_header + 'mini/experience-card/add'; //新增体验卡
export const experienceCardDelete = url_header + 'mini/experience-card/delete'; //删除体验卡
export const experienceCardUpdate = url_header + 'mini/experience-card/update'; //编辑体验卡

export const goodsList = url_header + 'mini/goods/list'; //实物列表
export const goodsInfo = url_header + 'mini/goods/info'; //实物详情
export const goodsAdd = url_header + 'mini/goods/add'; //新增实物
export const goodsDelete = url_header + 'mini/goods/delete'; //删除实物
export const goodsUpdate = url_header + 'mini/goods/update'; //编辑实物

export const updateConfig = url_header + 'admin/conf-info/get-config';//设置模块

export const checkTaskNum = url_header + 'mini/mini-task/check-task-num'; //判断企业每日订单数

